import { useMedia } from 'react-use';

import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';
import { css } from '@sorare/css';

/* Shorter viewports can't fit the phone-shaped dialog: use the full screen layout. */
export const dialogLayout = `${laptopAndAbove} and (min-height: 680px)`;

export const useIsDialogLayout = () => useMedia(dialogLayout);

export const baseLayout = css`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content 1fr calc(16 * var(--unit));
  grid-template-areas: 'top' 'center' 'bottom';
  align-items: center;
  justify-items: center;
  overflow: clip;
  gap: var(--double-unit);
  user-select: none;
`;

/* Goes on a Centered. */
export const topArea = css`
  grid-area: top;
  align-items: flex-start;
  width: 100%;
`;

export const bottomArea = css`
  grid-area: bottom;
  margin-top: auto;
  padding: var(--double-unit);
  &[data-hidden] {
    visibility: hidden;
  }
`;

export const centerArea = css`
  --margin-bottom-center-area: calc(5 * var(--unit));
  grid-area: center;
  --stripe-height: 32px;
  --card-width: 190px;
  position: relative;
  min-height: 0;
  min-width: 0;
  height: 100%;
  display: grid;
  place-items: center;
  place-content: center;
  gap: var(--unit);
`;

export const cardWrapper = css`
  height: 100%;
  width: 100%;
  max-width: var(--card-width);
  aspect-ratio: var(--card-aspect-ratio);
`;
